import React from 'react';

const InterestFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.8008 7.59998H15.6008C16.4495 7.59998 17.2634 7.93712 17.8635 8.53723C18.4636 9.13735 18.8008 9.95128 18.8008 10.8C18.8008 11.6487 18.4636 12.4626 17.8635 13.0627C17.2634 13.6628 16.4495 14 15.6008 14H14.8008"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7.59998H14.8V14.8C14.8 15.6487 14.4629 16.4626 13.8627 17.0627C13.2626 17.6628 12.4487 18 11.6 18H5.2C4.35131 18 3.53737 17.6628 2.93726 17.0627C2.33714 16.4626 2 15.6487 2 14.8V7.59998Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.19922 2V4.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.40039 2V4.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.5996 2V4.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default InterestFilterIcon;
